import './clubsview.scss'

import {
  READY,
  useVisualState,
} from '../../../../hooks/useVisualState';
import React, { useCallback, useEffect } from 'react';

import Button from '../../../../components/Button/Button'
import { ClubCard } from '../../../../components/Cards/ClubCard/ClubCard'
import Icon from '../../../../components/Icon/Icon'
import TextField from '../../../../components/TextField/TextField'
import t from '../../../../helpers/i18n'
import { withRouter } from 'react-router-dom'

const ClubsView = ({ history, match }) => {
  const [[clubsState, clubs], setClubs] = useVisualState()

  const handleFilters = useCallback(() => {}, [])
  const handleImport = useCallback(() => {}, [])

  const handleInvite = useCallback(() => {
    history.push('/soccer/clubs/invite')
  }, [history])

  useEffect(() => {
    setClubs(READY, {
      from: 1,
      to: 100,
      total: 328,
      list: [
        {
          clubId: 1,
          clubName: 'Grupo Biz F.C.',
          sportSubtypes: ['Football 7', 'Soccer', 'Football 11'],
          ownerName: 'Lionel Andrés',
          clubType: 'Family Club',
          ownerNumberPhone: '51 (33) 1600 2653'
        },
        {
          clubId: 2,
          clubName: 'Grupo Biz F.C.',
          sportSubtypes: ['Football 7', 'Soccer', 'Football 11'],
          ownerName: 'Lionel Andrés',
          clubType: 'Family Club',
          ownerNumberPhone: '51 (33) 1600 2653'
        },
        {
          clubId: 3,
          clubName: 'Grupo Biz F.C.',
          sportSubtypes: ['Football 7', 'Soccer', 'Football 11'],
          ownerName: 'Lionel Andrés',
          clubType: 'Family Club',
          ownerNumberPhone: '51 (33) 1600 2653'
        }
      ]
    })

    /*     setClubs(LOADING);
    get('/soccer/clubs')
      .then((response) => {
        setClubs(READY, response);
      })
      .catch((error) => {
        setClubs(ERROR, error);
      }); */
  }, [setClubs])

  return (
    <div>
      <div className='clubs-view-header'>
        <div className='-title label-extra-large-basic'>{t('titles.Clubs')}</div>
        <div className='-slash'>/</div>
        <div className='-title label-extra-large-semibold'>{t('titles.Clubs')}</div>
        <div className='-pagination'>
          {clubs && t('%s - %s of %s', clubs.from, clubs.to, clubs.total)}
        </div>
        <div className='-search'>
          <TextField
            placeholder={t('placeholders.Search')}
            icon='search'
            size='field-sized'
          />
        </div>
        <div className='-between-components' />
        <Button
          label={t('buttons.Filters')}
          type='light'
          size='field-sized'
          icon='FilterIcon'
          color='neutral'
          onClick={() => handleFilters()}
        />
        <div className='-separator' />
        <Button
          label={t('buttons.Import')}
          type='light'
          size='field-sized'
          icon='ArrowImportIcon'
          color='green'
          onClick={() => handleImport()}
        />
        <div className='-between-components' />
        <Button
          label={t('buttons.Invite')}
          type='dark'
          size='field-sized'
          icon='GetIcon'
          color='green'
          onClick={() => handleInvite()}
        />
        <div className='-separator' />
        <div className='-help'>
          <Icon size={32} icon='HelpSupportIcon' />
        </div>
      </div>
      {clubsState === READY && (
        <div className='container-clubs'>
          <ul>
            {clubs.list.map((club) => (
              <ClubCard
                key={club.clubId}
                clubName={club.clubName}
                sportSubtypes={club.sportSubtypes}
                ownerName={club.ownerName}
                clubType={club.clubType}
                ownerNumberPhone={club.ownerNumberPhone}
                onClick={() => history.push(`/soccer/clubs/${club.clubId}`)}
              />
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}

export default withRouter(ClubsView)
